import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  {
    prefix: "CREATE_BOOKING_",
  }
);

export interface CreateBookingState extends IState {}

export interface CreateBookingSuccess extends ISuccessAction {
  IdProspect: number;
  IdUnidade: number;
  DataHoraAvaliacao: string;
}

const INITIAL_STATE: CreateBookingState = {
  data: {},
  loading: false,
  error: null,
};

const request = (state: CreateBookingState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreateBookingState, action: CreateBookingSuccess) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: CreateBookingState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createBooking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateBookingTypes = Types;
export const CreateBookingActions = Creators;
